<template>
    <tr>
        <td>{{className}}</td>
        <td>{{amount}}</td>
        <td>{{teacher}}</td>
    </tr>
</template>

<script>
    export default {
        name: "TableRow",
        props: ['className','amount', 'teacher']
    }
</script>

<style scoped>

</style>
